<ion-app>
<div [ngClass]="'layout'">
	<nav>
		<ion-header *ngIf="isMobile && isAuthenticated">
			<di-entete-mobile></di-entete-mobile>
		</ion-header>
		<div *ngIf="!isMobile && isAuthenticated">
			<di-entete-desktop [menuOpened]="menuOpened"></di-entete-desktop>
			<di-sidemenu-desktop [menuToggleFunction]="onMenuToggle" [menuOpened]="menuOpened"></di-sidemenu-desktop>
		</div>
	</nav>
	<main [class.main-desktop]="!isMobile && isAuthenticated" [class.menu-open]="menuOpened" [class.isMultiWS]="isMultiWS">
		<ion-router-outlet [class.router-desktop]="!isMobile && isAuthenticated" id="content" main [class.router-mobile]="isMobile && isAuthenticated"> </ion-router-outlet>
		<!-- Ordre des templates est important : permet de savoir quels composants peuvent être affichés au dessus des autres -->
		<ng-template #panneauContainer></ng-template>
		<ng-template #drawerContainer></ng-template>
		<ng-template #popoverContainer></ng-template>
		<ng-template #loaderContainer></ng-template>
	</main>
</div>
</ion-app>